import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M11.1636 9.99961L7.22607 6.06211L8.0001 5.28809L12.7116 9.99961L8.0001 14.7111L7.22607 13.9371L11.1636 9.99961Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map